export default __webpack_public_path__ + "static/media/logo-partner-4.37f472d1.png";